module.exports = __webpack_public_path__ + "img/line_banner_m.46f1d321.jpg";